import Conf from '../../configuration'

export default {

    name: function () {

        return getEnv()

    },

    isProd: function () {

        return getEnv() === 'production'
    },

    isLocal: function () {

        return getEnv() === 'local'
    }

}


function getEnv() {

    if (window.location.hostname.indexOf('cleanfox.io') > -1) {
        return 'production'
    } else if (window.location.hostname.indexOf('staging') > -1) {
        return 'staging'
    } else if (window.location.hostname.indexOf('sandbox') > -1) {
        return 'sandbox'
    } else {
        return 'local'
    }
}
